import {
  USR_LOGIN_START,
  USR_LOGOUT_START,
  USR_SETUSER_START,
} from "../../const/actionTypes";

export const Login = (payload) => ({
  type: USR_LOGIN_START,
  payload,
});
export const SetUser = (payload) => ({
  type: USR_SETUSER_START,
  payload,
});

export const Logout = (payload) => ({
  type: USR_LOGOUT_START,
  payload,
});
